import type { Quiz, QuizTotal } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';

import { EditQuizTotalCriteria } from './edit-quiz-total-criteria.gts';
import { EditQuizTotalFeedback } from './edit-quiz-total-feedback.gts';
import type { TotalEditingMode } from './utils.ts';

const TotalEditorCards: TemplateOnlyComponent<{
  Args: {
    total: QuizTotal;
    index: number;
    quiz: Quiz;
    isEditingMode: (index: number, mode: TotalEditingMode) => boolean;
  };
}> = <template>
  {{#if (@isEditingMode @index "criteria")}}
    <div
      class="card rounded-top-0 border-top-0 bg-primary-subtle ll-question-criteria-editor-total w-100"
    >
      <EditQuizTotalCriteria @total={{@total}} @quiz={{@quiz}} />
    </div>
  {{else if (@isEditingMode @index "feedback")}}
    <div
      class="card rounded-top-0 border-top-0 bg-primary-subtle ll-question-feedback-editor-total w-100"
    >
      <EditQuizTotalFeedback @total={{@total}} />
    </div>
  {{/if}}
</template>;

export default TotalEditorCards;
